import { ContractWaitingLoader, ErrorPage } from '@applyonline/shared'
import { EFinancingProgram } from '@if/core/types'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { contractIsReceived } from '../ViewCreditApplication/HardHitApprovedResultPage/hooks'

const ContractWaitingPage = () => {
  const { id } = useParams<{ id: string }>()
  const { t } = useTranslation()

  if (!id) return <ErrorPage title={t('common.notFound')} />

  return (
    <ContractWaitingLoader 
      creditAppId={id} 
      financingProgram={EFinancingProgram.MechanicalWarranty}
      contractIsReceived={(creditApp) => contractIsReceived(null, creditApp)}
    />
  )
}

export default ContractWaitingPage